// Helper function to parse AWSJSON fields from AppSync
const parseKycItem = (item) => {
    if (!item) return item;
    const parsed = { ...item };
    const jsonFields = [
        'organization', 'customerRisk', 'transactionRisk', 'industryRisk',
        'geographicalRisk', 'productServiceRisk', 'parentCompanyRisk',
        'regulatoryProceedings', 'enhancedDueDiligence', 'clientAdvisor',
        'underwriter', 'complianceOfficer'
    ];
    jsonFields.forEach(field => {
        if (parsed[field] && typeof parsed[field] === 'string') {
            try {
                parsed[field] = JSON.parse(parsed[field]);
            } catch (e) {
                console.warn(`Failed to parse ${field}:`, e);
            }
        }
    });
    // Parse additionalFiles array items
    if (parsed.additionalFiles && Array.isArray(parsed.additionalFiles)) {
        parsed.additionalFiles = parsed.additionalFiles.map(file => {
            if (typeof file === 'string') {
                try {
                    return JSON.parse(file);
                } catch (e) {
                    return file;
                }
            }
            return file;
        });
    }
    return parsed;
};

function kyc(state ={isLoading: false}, action) {
    switch (action.type) {
        case 'GET_S3_FILE_REQUEST':
            return {...state, isLoading: true} 
        case 'GET_S3_FILE_SUCCESS':
            return {...state, isLoading: false} 
        case 'GET_S3_FILE_FAILURE':
            return {...state, isLoading: false}
        case 'SET_IS_LOADING':
            return {...state, isLoading: true}
        case 'SET_NOT_LOADING':
            return {...state, isLoading: false}
        case 'POST_CREATE_KYC_REQUEST':
            return {...state, isLoading: true} 
        case 'POST_CREATE_KYC_SUCCESS':
            const currentKycs = state.allKycs || []
            return {...state,
                isLoading: false,
                allKycs: [...currentKycs, action.data]
            }
        case 'POST_CREATE_KYC_FAILURE':
            return {...state, isLoading: false}
        case 'PUT_UPDATE_KYC_REQUEST':
            return {...state, isLoading: true}
        case 'PUT_UPDATE_KYC_SUCCESS':
            console.log('PUT_UPDATE_KYC_SUCCESS', action);
            let targetPatchKyc = (action && action.data) || {}
            const patchKycHits = state.allKycs.map((eachHit) => {
                if (eachHit.id === targetPatchKyc.id) return targetPatchKyc
                return eachHit
            })
            return {...state, isLoading: false, allKycs: patchKycHits}
        case 'PUT_UPDATE_KYC_FAILURE':
            return {...state, isLoading: false}
        case 'DELETE_KYC_REQUEST':
            return {...state, isLoading: true}
        case 'DELETE_KYC_SUCCESS':
            console.log('DELETE_KYC_SUCCESS', action);
            return {...state, isLoading: false}
        case 'DELETE_KYC_FAILURE':
            return {...state, isLoading: false}
        case 'POST_KYCS_SEARCH_REQUEST':
            return {...state, isLoading: true}
        case 'POST_KYCS_SEARCH_SUCCESS':
            console.log('POST_KYCS_SEARCH_SUCCESS', action);
            // Handle AppSync/GraphQL response format (data is double-nested: axios.data -> graphql.data)
            const kyc_items_raw = (action && action.data && action.data.data && action.data.data.listKYCs && action.data.data.listKYCs.items) || [];
            const kyc_items = kyc_items_raw.map(parseKycItem);
            const kyc_nextToken = (action && action.data && action.data.data && action.data.data.listKYCs && action.data.data.listKYCs.nextToken) || null;
            const totalHitsKYCs = kyc_items.length;
            return {...state,
                allKycs: kyc_items,
                totalHitsKYCs: totalHitsKYCs,
                kyc_nextToken: kyc_nextToken,
                isLoading: false
            }
        case 'POST_KYCS_SEARCH_FAILURE':
            return {...state, isLoading: false}
        case 'POST_KYCS_SEARCH_AFTER_REQUEST':
            return {...state, isLoading: true}
        case 'POST_KYCS_SEARCH_AFTER_SUCCESS':
            console.log('POST_KYCS_SEARCH_AFTER_SUCCESS', action);
            // Handle AppSync/GraphQL response format (data is double-nested: axios.data -> graphql.data)
            const nextKYCItemsRaw = (action && action.data && action.data.data && action.data.data.listKYCs && action.data.data.listKYCs.items) || [];
            const nextKYCItems = nextKYCItemsRaw.map(parseKycItem);
            const next_kyc_nextToken = (action && action.data && action.data.data && action.data.data.listKYCs && action.data.data.listKYCs.nextToken) || null;
            const combinedKYCsHits = [...state.allKycs]
            const combinedKycIDs = {};
            combinedKYCsHits.forEach((eachHit) => combinedKycIDs[eachHit.id] = true)
            nextKYCItems.forEach((newHit) => {
                if (!combinedKycIDs[newHit.id]) {
                    combinedKYCsHits.push(newHit)
                }
            })
            return {...state,
                allKycs: combinedKYCsHits,
                totalHitsKYCs: combinedKYCsHits.length,
                kyc_nextToken: next_kyc_nextToken,
                isLoading: false
            }
        case 'POST_KYCS_SEARCH_AFTER_FAILURE':
            return {...state, isLoading: false}
        case 'CLEAR_KYC_SEARCH':
            return {...state, allKycs: [], totalHitsKYCs: 0, kyc_nextToken: null, isLoading: false}
      default:
        return state
    }
  }

export default kyc